module.exports = __webpack_public_path__ + "img/case_pic06.da57cfe3.png";